import screeningListService from "./screeningListService";

const screeningPrintService = [
    ...screeningListService
];

export { screeningPrintService as default, screeningListService }